import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { ApplicationPageComponent } from './pages/friend/components/application-page/application-page.component';
import { GameLikeCollectionComponent } from './pages/minigame/game-like-collection/game-like-collection.component';
import { GameRecentPlayedComponent } from './pages/minigame/game-recent-played/game-recent-played.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { DepositRedirectComponent } from './pages/top-up/deposit-redirect.component';
import { AuthGuard } from './shared/service/auth.guard';

const routes: Routes = [
  //默认跳转首页
  { path: '', redirectTo: window.languageCode, pathMatch: 'full' },
  { path: '404', component: PageNotFoundComponent },
  //將此頁從頁頭目錄頁尾分離
  { path: ':languageCode/referral/application/affiliate', component: ApplicationPageComponent },
  {
    path: ':languageCode',
    component: BasicLayoutComponent,
    children: [
      //首页
      {
        path: '',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
      },
      // 活动单页
      { path: 'activity', loadChildren: () => import('./pages/activity/activity.module').then(m => m.ActivityModule) },
      //用户中心
      {
        path: 'personal-center',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/user-center/user-center.module').then(m => m.UserCenterModule),
      },
      //资产管理
      {
        path: 'my-wallet',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/user-asset/user-assets.module').then(m => m.UserAssetsModule),
      },

      // // //登录
      // { path: 'login', canActivateChild: [LoginGuard], loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
      // // //注册
      // { path: 'register', canActivateChild: [LoginGuard], loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule) },
      //忘记密码 //TODO:delete
      // {
      //   path: 'forget-password',
      //   canActivateChild: [LoginGuard],
      //   loadChildren: () => import('./pages/password/password.module').then(m => m.PasswordModule),
      // },
      //手机验证器
      {
        path: 'verification',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/verification/verification.module').then(m => m.VerificationModule),
      },
      // //充值
      // {
      //   path: 'deposit',
      //   canActivateChild: [AuthGuard],
      //   loadChildren: () => import('./pages/top-up/top-up.module').then(m => m.TopUpModule),
      // },
      { path: 'deposit', component: DepositRedirectComponent },
      // //提现
      // {
      //   path: 'withdrawal',
      //   canActivateChild: [AuthGuard],
      //   loadChildren: () => import('./pages/withdraw/withdraw.module').then(m => m.WithdrawModule),
      // },
      // //兑换
      // {
      //   path: 'exChange',
      //   canActivateChild: [AuthGuard],
      //   loadChildren: () => import('./pages/exchange/exchange.module').then(m => m.ExchangeModule),
      // },
      //小游戏、体育首页、其它首页
      {
        matcher: (segments: UrlSegment[]) => {
          const hall = segments[0]?.path || '';
          if (['casino', 'live-casino', 'sports', 'other'].includes(hall)) {
            return {
              consumed: segments.length === 1 ? segments : segments.slice(0, 1),
              posParams: { hall: new UrlSegment(hall, {}) },
            };
          }
          return null;
        },
        loadChildren: () => import('./pages/minigame/minigame.module').then(m => m.MinigameModule),
      },
      //我的收藏
      { path: 'favorites', component: GameLikeCollectionComponent },
      //近期玩过
      { path: 'recentPlayed', component: GameRecentPlayedComponent },
      //第三方全窗口
      {
        path: 'play',
        loadChildren: () => import('./pages/full-play/full-play.module').then(m => m.FullPlayModule),
      },
      //维护
      { path: 'maintain', loadChildren: () => import('./pages/maintain/maintain.module').then(m => m.MaintainModule) },
      //原创游戏
      { path: 'original', loadChildren: () => import('./orignal/orignal.module').then(m => m.OrignalModule) },
      //红利和优惠 and vip
      {
        path: 'promotions',
        loadChildren: () => import('./pages/dividend-vip/dividend-vip.module').then(m => m.DividendVipModule),
      },
      //卡劵中心
      {
        path: 'voucher',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/voucher-center/voucher-center.module').then(m => m.voucherCenterModule),
      },
      //奖励明细模块 web and h5 推荐好友
      {
        path: 'referral',
        // canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/friend/friend.module').then(m => m.FriendModule),
      },
      //通知中心
      {
        path: 'notification-center',
        canActivateChild: [AuthGuard],
        loadChildren: () =>
          import('./pages/notification-center/notification-center.module').then(m => m.NotificationCenterModule),
      },
      //偏好设置
      {
        path: 'settings',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
      },
      //账户找回
      {
        path: 'retrieve-account',
        canActivateChild: [AuthGuard],
        loadChildren: () =>
          import('./pages/retrieve-account/retrieve-account.module').then(m => m.RetrieveAccountModule),
      },
      // 帮助中心
      {
        path: 'help-center',
        loadChildren: () => import('./pages/help-center/help-center.module').then(m => m.HelpCenterModule),
      },
      // 关于我们
      { path: 'about-us', loadChildren: () => import('./pages/about-us/about-us.module').then(m => m.AboutUsModule) },
      // 意见反馈
      { path: 'feedback', loadChildren: () => import('./pages/feedback/feedback.module').then(m => m.FeedbackModule) },
      // 节制博彩首页
      {
        path: 'responsible-gambling',
        loadChildren: () =>
          import('./pages/responsible-gambling/responsible-gambling.module').then(m => m.ResponsibleGambling),
      },
      //偏好设置
      {
        path: 'global-settings',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/global-settings/global-settings.module').then(m => m.GlobalSettingsModule),
      },
      // My bet 交易记录
      {
        path: 'my-bet',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/my-bet/my-bet.module').then(m => m.MyBetModule),
      },
      // 钱包交易记录
      {
        path: 'transaction',
        canActivateChild: [AuthGuard],
        loadChildren: () =>
          import('./pages/user-asset/wallet-history/wallet-history.module').then(m => m.WalletHistoryModule),
      },
      // 電競体育首页
      {
        path: 'esports',
        loadChildren: () => import('./pages/e-sports/e-sports.routes').then(m => m.routes),
      },
    ],
  },
  //master5 member layout
  // {
  //   path: ':languageCode/member',
  //   component: MemberLayoutComponent,
  //   children: [
  //     {
  //       path: '',
  //       canActivateChild: [AuthGuard],
  //       loadChildren: () => import('./layouts/member-content/member-content.module').then(m => m.MemberContentModule),
  //     },
  //   ],
  // },
  // 404页面
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
